import React, { useState, useEffect } from "react";
import { Table, TableBody, TableRow, TableCell } from "@material-ui/core";
import useTableScroll from "../../components/useTableScrollcesar";
import { Dimmer } from "../spinner";
import axios from "axios";
import moment from "moment";
import { formatMoneda } from "../../util/varios";
import { RegistrarPago } from "./modalRegistrarPago";
import { MensajeSiNo } from "../../components/mensajes";

function PagosRegistros(props) {
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const op = require("../../../public/modulos/datos");

  const headCells = [
    { label: "Código", textAlign: "center" },
    { label: "Nombre/Razón Social", textAlign: "center" },
    { label: "Intereses", textAlign: "center" },
    { label: "Recargos", textAlign: "center" },
    { label: "Multa", textAlign: "center" },
    { label: "Total Factura", textAlign: "center" },
    { label: "Estatus", textAlign: "center" },
  ];

  const [selectedID, setSelectedID] = useState(null);
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const [idTipoIngreso, setIdtipoIngreso] = useState(null);
  const [idFactura, setIdFactura] = useState(null);
  const [numFactura, setNumFactura] = useState(null);
  const [itemSelect, setItemSelect] = useState(-1);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mostrar2, setMostrar2] = useState(false);
  const [activate, setActivate] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [factuPago, setFactuPago] = useState([]);
  const [deuda, setDeuda] = useState([]);
  const [verificacion, setVerificacion] = useState([]);
  const [totPagar, setTotPagar] = useState("0,00");
  const [concepto, setConcepto] = useState("");
  const [datosFac, setDatosFac] = useState();
  const [facturaDet, setFacturaDet] = useState();

  useEffect(() => {
    if (props.facturas) {
      setFactuPago(props.facturas);
      let total = 0.0;
      for (let i = 0; i < props.facturas.length; i++) {
        total = parseFloat(total) + parseFloat(props.facturas[i].totalfactura);
      }
      if (total > 0) {
        setSelectedID(0);
        setBtnDisabled(false);
        setConcepto(props.facturas[0].descripcion);
        setItemSelect(0);
      } else {
        setSelectedID(null);
        setBtnDisabled(true);
        setConcepto("");
      }
      setTotPagar(
        formatMoneda(total.toString().replace(".", ","), ",", ".", 2)
      );
    }
  }, [props.facturas]);

  useEffect(() => {
    let total = 0.0;
    for (let i = 0; i < factuPago.length; i++) {
      total = parseFloat(total) + parseFloat(props.facturas[i].totalfactura);
    }
    if (total > 0) {
      setSelectedID(0);
      setBtnDisabled(false);
      setConcepto(props.facturas[0].descripcion);
      setItemSelect(0);
    } else {
      setSelectedID(null);
      setBtnDisabled(true);
      setConcepto("");
    }
    setTotPagar(formatMoneda(total.toString().replace(".", ","), ",", ".", 2));
  }, [factuPago]);

  const { TblContainer, TblHead } = useTableScroll(headCells);

  const cargarPagos = () => (e) => {
    e.preventDefault();
    if (factuPago.length > 0) {
      setIdtipoIngreso(factuPago[selectedID].idtipoingreso);
      setIdFactura(factuPago[selectedID].idfactura);
      setNumFactura(factuPago[selectedID].numfactura);
      setDatosFac(factuPago[selectedID]);
      setFacturaDet();
      if (
        factuPago[selectedID].idcontribuyente === "0" ||
        factuPago[selectedID].idcontribuyente === null
      ) {
        if (props.tipo === 2) {
          seleccionarVerificacion();
        } else {
          setMostrar2(true);
        }
      } else {
        seleccionarDetalleFactura();
      }
    }
  };

  const procesarEliminar = () => (e) => {
    e.preventDefault();
    let msg = "";
    if (factuPago[selectedID].status === 1) {
      msg = "No se puede eliminar la factura ya fue procesada.";
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: msg,
        icono: "informacion",
      });
    } else if (factuPago[selectedID].status === 0) {
      msg = "Esta Seguro de Eliminar el Registro?.";
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    setActivate(true);
    eliminarFactura();
  };

  const eliminarFactura = () => {
    const endpoint = `${op.conexion}/api/Caja_Ingreso/eliminarfactura/${factuPago[selectedID].idfactura}`;

    axios
      .post(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);
          seleccionarFacturas();
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const seleccionarFacturas = () => {
    let campos = "*";
    let nomtab = "factura";
    let fe = "'" + moment(fechaSistema).format("YYYY-MM-DD") + "'";
    let sta = 0;
    let condi = `facturador = ${idusuario} AND fechaemision = ${fe} AND status = ${sta}`;
    let orden = "1";
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            let total = 0.0;
            for (let i = 0; i < response.data.length; i++) {
              total =
                parseFloat(total) + parseFloat(response.data[i].totalfactura);
            }
            if (total > 0) {
              setSelectedID(0);
              setBtnDisabled(false);
              setConcepto(response.data[0].descripcion);
              setItemSelect(0);
            } else {
              setSelectedID(null);
              setBtnDisabled(true);
              setConcepto("");
            }
            setTotPagar(
              formatMoneda(total.toString().replace(".", ","), ",", ".", 2)
            );

            setFactuPago(response.data);
          } else {
            setFactuPago([]);
            setTotPagar("0,00");
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const seleccionarDetalleFactura = () => {
    setActivate(true);
    let campos = "*";
    let nomtab = "facturadetalle";
    let nomid = "idfactura";
    let valor = factuPago[selectedID].idfactura;
    let orden = "idfacturadetalle";
    let endpoint = `${op.conexion}/api/consulta/modelirows?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${valor}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setFacturaDet(response.data);
          SelectDeuda(factuPago[selectedID].idcontribuyente, response.data);
          //setMostrar2(true);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const SelectDeuda = (id, facdet) => {
    setActivate(true);
    let tab =
      factuPago[selectedID].tablacontribuyente.trim() === "produccion"
        ? "configproduccion"
        : factuPago[selectedID].tablacontribuyente.trim() === "1x500"
        ? "config1x500"
        : factuPago[selectedID].tablacontribuyente.trim() === "minas"
        ? "configminas"
        : "configexpendedores";
    let tipod =
      factuPago[selectedID].tablacontribuyente.trim() === "produccion"
        ? "(tipodeuda = 2 or tipodeuda=22 or tipodeuda=222)"
        : factuPago[selectedID].tablacontribuyente.trim() === "1x500"
        ? "(tipodeuda = 3 or tipodeuda=33 or tipodeuda=333)"
        : factuPago[selectedID].tablacontribuyente.trim() === "minas"
        ? "(tipodeuda = 1 or tipodeuda=11 or tipodeuda=111)"
        : "(tipodeuda = 4 or tipodeuda=44 or tipodeuda=444)";

    let endpoint = `${op.conexion}/api/minas/deudas?idagente=${id}&fecha=${fechaSistema}&tabconf=${tab}&condic=${tipod}`;
    console.log(endpoint);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          let deu = [];
          let mul = [];
          let his = [];
          let dism = 0;
          let disd = 0;
          let totdeu = parseFloat(0.0);
          for (let i = 0; i < response.data.length; i++) {
            for (let x = 0; x < facdet.length; x++) {
              if (response.data[i].iddeu === facdet[x].iddeuda) {
                deu.push({
                  anio: response.data[i].anio,
                  mes: response.data[i].mes.replace("'", "").replace("'", ""),
                  monto: response.data[i].mondeu,
                  intereses: response.data[i].intmoradeu,
                  recargo: response.data[i].recargodeu,
                  multa: response.data[i].multa,
                  retenciones: response.data[i].retencion,
                  credito: response.data[i].acreditacion,
                  totalperi: response.data[i].subtotal,
                  status: response.data[i].estatus,
                  idfac: response.data[i].idfact,
                  nummes: response.data[i].nmes,
                  estatusfac: response.data[i].estatusfac,
                  tipotransaccion: response.data[i].tipotransaccion,
                  tipodeuda: response.data[i].tipodeu,
                  iddeu: response.data[i].iddeu,
                  tipod: response.data[i].tipod,
                  idagente: response.data[i].idagente,
                });
              }
            }
          }

          setDeuda(deu);
          setMostrar2(true);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarVerificacion = () => {
    setActivate(true);
    let endpoint = `${
      op.conexion
    }/api/Caja_Ingreso/selectverificacionbyid?idverificacion=${parseInt(
      factuPago[selectedID].numfactura.substring(1)
    )}`;
    console.log(endpoint);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setVerificacion(response.data);
          setMostrar2(true);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  return (
    <div className="titulos">
      <RegistrarPago
        show={mostrar2}
        tipo={idTipoIngreso}
        fecha={fechaSistema}
        idfactura={idFactura}
        numfactura={numFactura}
        factura={datosFac}
        facturadet={facturaDet}
        deuda={deuda}
        verificacion={verificacion}
        onHideRenderizar={seleccionarFacturas}
        onHideCancelar={() => {
          setMostrar2(false);
          setDeuda([]);
        }}
      />
      <div className="p-2 title-table"></div>
      <div className="container amanecergris">
        <div className="row py-2 col-md-12">
          <div className="bg-light col-md-10 col-12 px-0">
            <Dimmer active={activate} />
            <MensajeSiNo
              mensaje={mensajesino}
              onHideNo={() =>
                setMensajesino({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                })
              }
              onHideSi={handleCloseSi}
            />
            <div id="declaraciones">
              <TblContainer
                container={{
                  height: 280,
                  maxHeight: 380,
                  width: "100%",
                  overflow: "auto",
                }}
              >
                <TblHead />
                <TableBody className="table-bordered">
                  {factuPago &&
                    factuPago.map((deu, index) => (
                      <TableRow
                        key={index}
                        onClick={() => {
                          setSelectedID(index);
                          setConcepto(factuPago[index].descripcion);
                          setItemSelect(index);
                        }}
                        style={{
                          padding: "0",
                          cursor: "pointer",
                          background:
                            itemSelect === index ? "lightskyblue" : "white",
                        }}
                      >
                        <TableCell className="p-0 text-center">
                          {deu.idcontribuyente > 0 ? deu.idcontribuyente : ""}
                        </TableCell>
                        <TableCell className="p-0 text-center">
                          {deu.nombrecontri.trim()}
                        </TableCell>
                        {/*  <TableCell className='p-0 text-center'>{deu.tablacontribuyente.trim()}</TableCell> */}
                        {/* <TableCell className='p-0'>{formatMoneda(deu.totalinmpuesto.replace(',', '').replace('.', ','), ',', '.', 2)}</TableCell> */}
                        <TableCell className="p-0 text-right">
                          {formatMoneda(
                            deu.totalinteres.replace(",", "").replace(".", ","),
                            ",",
                            ".",
                            2
                          )}
                        </TableCell>
                        <TableCell className="p-0 text-right">
                          {formatMoneda(
                            deu.totalrecargo.replace(",", "").replace(".", ","),
                            ",",
                            ".",
                            2
                          )}
                        </TableCell>
                        <TableCell className="p-0 text-right">
                          {formatMoneda(
                            deu.totalmulta.replace(",", "").replace(".", ","),
                            ",",
                            ".",
                            2
                          )}
                        </TableCell>
                        {/* <TableCell className='p-0'>{formatMoneda(deu.deducible.replace(',', '').replace('.', ','), ',', '.', 2)}</TableCell> */}
                        <TableCell className="p-0 text-right">
                          {formatMoneda(
                            deu.totalfactura.replace(",", "").replace(".", ","),
                            ",",
                            ".",
                            2
                          )}
                        </TableCell>
                        <TableCell className="p-0 text-center">
                          {deu.status === 0 ? "Por Procesar" : "Procesada"}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </TblContainer>
              <div
                className="row col-12 p-0 m-0 border-table"
                style={{ borderTopStyle: "hidden" }}
              >
                <div className="col-md-10">
                  <div className="input-group input-group-sm">
                    <label className="fw-bold" id="inputGroup-sizing-sm">
                      Detalle de la Factura:
                    </label>
                    <p className="px-2 mt-1">{concepto}</p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row col-md-4 col-12 p-0 m-0 border-table ml-auto"
              style={{ borderTopStyle: "hidden" }}
            >
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell className="text-right">
                      <label className="fw-bold">
                        Total a Pagar: {totPagar}
                      </label>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </div>
          </div>
          <div className="col-md-2 px-0 py-2 m-auto">
            <button
              disabled={btnDisabled}
              onClick={cargarPagos()}
              className="btn btn-sm rounded-pill btn-success col-8 ml-5"
            >
              <i className="fas fa-share"> Registrar Pago</i>
            </button>
            <div className="col-12 py-1"></div>
            <button
              disabled={btnDisabled}
              onClick={procesarEliminar()}
              className="btn btn-sm rounded-pill btn-danger col-8 ml-5"
            >
              <i className="fa fa-trash"> Eliminar Pago</i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PagosRegistros;



// WEBPACK FOOTER //
// ./src/components/ingresos/registrarpagos.js